import PageHeader from '~/common/components/GlobalLayout/PageHeader';

import FormTemplate from './FormTemplate';

type FormTemplateWithAuditHistoryProps = {
  schema?: {
    title?: string;
  };
  isAiSwitchButtonEnabled?: boolean;
};

export default function FormTemplateWithAuditHistory({
  schema: { title } = {},
  isAiSwitchButtonEnabled = false,
  ...props
}: Readonly<FormTemplateWithAuditHistoryProps>) {
  return (
    <FormTemplate
      {...props}
      customHeader={
        <PageHeader
          title={title}
          isAiSwitchButtonEnabled={isAiSwitchButtonEnabled}
        />
      }
    />
  );
}
